import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import Swal from "sweetalert2";
import { API_BASE_URL } from "../Config/Config";
import CommonFooter from "../../../core/common/footer/commonFooter";
import { Select } from "antd";
import { Spin } from "antd";
import axios from "axios";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const DbHealth = () => {
  const [organizations, setOrganizations] = useState([]);
  const [selectedDatabase, setSelectedDatabase] = useState(null);
  console.log(selectedDatabase, "selecteddatabase");
  const [dbHealthData, setDbHealthData] = useState([]);
  console.log(dbHealthData, "jsdbchjavhxhjkabvhgxvcabsjx");
  const [addLoading, setAddLoading] = useState(false);

  const getQuerys = async () => {
    setAddLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/getdbquery`);
      const data = response.data?.ResultData || [];

      // Map API → react-select format
      const mappedOptions = data.map((item) => ({
        value: item.Id, // ✅ DB ID
        label: item.Database, // ✅ DB Name
      }));

      setOrganizations(mappedOptions);

      // ✅ Auto select first database
      if (mappedOptions.length > 0) {
        setSelectedDatabase(mappedOptions[0]);
        executeDbApi(mappedOptions[0].value);
      }
    } catch (error) {
      console.error("Error fetching databases:", error);
    } finally {
      setAddLoading(false);
    }
  };

  const executeDbApi = async (ID) => {
    setAddLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/getdbhealth?ServiceTypeId=${ID}`,
      );

      const data = response.data?.ResultData || [];
      setDbHealthData(data);
    } catch (error) {
      console.error("Error fetching db health:", error);
    } finally {
      setAddLoading(false);
    }
  };

  useEffect(() => {
    getQuerys();
  }, []);
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      {addLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spin size="large" />
        </div>
      )}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>DB Health</h4>
                <h6>Manage your Database Health</h6>
              </div>
            </div>
            <ul className="table-top-head">
              
               <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
              </ul>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <div className="search-set">
                {" "}
                <Select
                  style={{ width: 200 }}
                  placeholder="Select Database"
                  options={organizations}
                  value={selectedDatabase}
                  onChange={(val) => {
                    setSelectedDatabase(val);
                    executeDbApi(val); // ✅ Pass ID
                  }}
                />
              </div>
            </div>
          </div>

          {!addLoading && dbHealthData.length > 0 && (
            <div className="card mt-4">
              <div className="card-header">
                <h5 className="mb-0">
                  DB Health Status – {selectedDatabase?.label}
                </h5>
              </div>

              <div className="card-body table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      {Object.keys(dbHealthData[0]).map((key) => (
                        <th key={key}>{key}</th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {dbHealthData.map((row, index) => (
                      <tr key={index}>
                        {Object.values(row).map((value, i) => (
                          <td key={i}>{String(value)}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <CommonFooter />
        </div>
      </div>
    </>
  );
};
export default DbHealth;
